import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

import { UserSuccessOutput } from './types';

export interface IDeleteUsers {
  deleteUsers: UserSuccessOutput;
}

export const DELETE_USERS = gql`
  mutation deleteUsers($usernames: [String!]!) {
    deleteUsers(usernames: $usernames) {
      status_code
      body {
        data
        message
        success
      }
    }
  }
`;

export const useDeleteUsers = (
  options: MutationHookOptions<IDeleteUsers, OperationVariables>,
) => {
  return useMutation<IDeleteUsers, OperationVariables>(DELETE_USERS, options);
};
